export const STATE_KEY = "app:state" as const;
